import { Component, Injectable, ViewChild } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { GlobalFilterSharedService } from '../../services/global-filter-shared.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import { AuthService } from '../../../core/service/auth.service';
import {
  TeamHierarchy,
  UserTeamHierarchy,
} from '../../../home/administration/team-management/models/team.model';
import { TeamService } from '../../../home/administration/team-management/services/team.service';
import { GlobalFilterService } from '../../services/global-filter.service';

interface HierarchyNode {
  id: string;
  name: string;
  children?: HierarchyNode[];
}

interface HierarchyFlatNode {
  expandable: boolean;
  id: string;
  name: string;
  level: number;
}

@Component({
  selector: 'app-team-global-filter',
  templateUrl: './team-global-filter.component.html',
  styleUrls: ['./team-global-filter.component.scss'],
})
export class TeamGlobalFilterComponent {
  isTeamManager: boolean;
  isPrivilegedUser: boolean;

  selectedTeamName: string;
  currentUserId: string = '';

  modalRef: BsModalRef;
  dataSubject: Subscription;
  isLoading: boolean = false;
  teamHierarchicalResponse: UserTeamHierarchy;
  @ViewChild('template', { static: true }) template: any;
  destroy: ReplaySubject<any> = new ReplaySubject<any>(1);

  private _transformer = (node: HierarchyNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      id: node.id,
      name: node.name,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<HierarchyFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: HierarchyFlatNode) => node.expandable;

  constructor(
    private teamService: TeamService,
    private authService: AuthService,
    private modalService: BsModalService,
    public globalFilterService: GlobalFilterService,
    private globalFilterSharedService: GlobalFilterSharedService
  ) {
    this.dataSubject = globalFilterSharedService
      .getSubjectOpenGlobalFilterModal()
      .pipe(takeUntil(this.destroy))
      .subscribe((sortByOpen: string) => {
        if (sortByOpen == 'Open') {
          this.currentUserId = this.authService.currentUserValue?.id!;

          this.isTeamManager = this.authService.isTeamManager();
          this.isPrivilegedUser = this.authService.isPrivilegedUser();

          this.dataSource = new MatTreeFlatDataSource(
            this.treeControl,
            this.treeFlattener
          );

          this.showModal();
          this.getTeamHierarchicalResponse();
        }
      });
  }

  ngOnInit() {}

  private showModal() {
    this.modalRef = this.modalService.show(this.template, {
      class: 'modal-dialog-right modal-lg',
    });
  }

  handleCancel() {
    this.globalFilterSharedService.setSubjectOpenGlobalFilterModal('');
    this.modalRef?.hide();
  }

  getTeamHierarchicalResponse() {
    this.isLoading = true;
    this.teamService
      .getUserTeamHierarchicalResponse(
        this.currentUserId,
        this.isPrivilegedUser
      )
      .subscribe(
        (teamHierarchicalResponse: UserTeamHierarchy) => {
          this.isLoading = false;
          this.teamHierarchicalResponse = teamHierarchicalResponse;

          this.dataSource.data = teamHierarchicalResponse.teamHierarchy;
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  openTeamUserModal(node: any) {
    this.selectedTeamName = node.name;
    this.globalFilterSharedService.setSubjectTeamUsersAddModal(node.id);
  }

  isGreen(teamId: string) {
    var isTeamInclude =
      this.globalFilterService
        .getSelectedTeamUser()
        ?.map((item) => item.teamId)
        ?.includes(teamId) ?? false;

    return isTeamInclude;
  }

  isPrivilegedUserSelected() {
    var selectedPrivilegedUserIds =
      this.globalFilterService.getSelectedPrivilegedUserIds() ?? [];
    return selectedPrivilegedUserIds.length > 0;
  }

  clearAllUser() {
    this.globalFilterService.setSelectedTeamUser([]);
    this.globalFilterService.setSelectedPrivilegedUserIds([]);

    this.globalFilterSharedService.setSubjectApplyGlobalFilter(true);
  }

  openPrivilegedUserModal() {
    this.globalFilterSharedService.setSubjectPrivilegedUsersAddModal(
      this.teamHierarchicalResponse?.referenceUsers
    );
  }

  ngOnDestroy() {
    this.modalRef?.hide();
    this.destroy.next(null);
    this.globalFilterSharedService.setSubjectOpenGlobalFilterModal('');
  }
}
